"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _tag = _interopRequireDefault(require("../tag"));

var _create = _interopRequireDefault(require("../utils/create"));

var _default = (0, _create.default)({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b({
        center: _vm.centered
      })
    }, [_vm.thumb || _vm.$slots.thumb ? _c('a', {
      class: _vm.b('thumb'),
      attrs: {
        "href": _vm.thumbLink
      }
    }, [_vm._t("thumb", [_vm.lazyLoad ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.thumb,
        expression: "thumb"
      }],
      class: _vm.b('img')
    }) : _c('img', {
      class: _vm.b('img'),
      attrs: {
        "src": _vm.thumb
      }
    })]), _vm.tag ? _c('van-tag', {
      class: _vm.b('tag'),
      attrs: {
        "mark": "",
        "type": "danger"
      }
    }, [_vm._v("\n      " + _vm._s(_vm.tag) + "\n    ")]) : _vm._e()], 2) : _vm._e(), _c('div', {
      class: _vm.b('content')
    }, [_vm._t("title", [_vm.title ? _c('div', {
      class: _vm.b('title')
    }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e()]), _vm._t("desc", [_vm.desc ? _c('div', {
      class: [_vm.b('desc'), 'van-ellipsis']
    }, [_vm._v("\n        " + _vm._s(_vm.desc) + "\n      ")]) : _vm._e()]), _vm._t("tags"), _c('div', {
      staticClass: "van-card__bottom"
    }, [_vm.isDef(_vm.price) ? _c('div', {
      class: _vm.b('price')
    }, [_vm._v("\n        " + _vm._s(_vm.currency) + " " + _vm._s(_vm.price) + "\n      ")]) : _vm._e(), _vm.isDef(_vm.originPrice) ? _c('div', {
      class: _vm.b('origin-price')
    }, [_vm._v("\n        " + _vm._s(_vm.currency) + " " + _vm._s(_vm.originPrice) + "\n      ")]) : _vm._e(), _vm.isDef(_vm.num) ? _c('div', {
      class: _vm.b('num')
    }, [_vm._v("\n        x " + _vm._s(_vm.num) + "\n      ")]) : _vm._e()])], 2), _vm.$slots.footer ? _c('div', {
      class: _vm.b('footer')
    }, [_vm._t("footer")], 2) : _vm._e()]);
  },
  name: 'card',
  components: {
    VanTag: _tag.default
  },
  props: {
    tag: String,
    desc: String,
    thumb: String,
    title: String,
    centered: Boolean,
    lazyLoad: Boolean,
    thumbLink: String,
    num: [Number, String],
    price: [Number, String],
    originPrice: [Number, String],
    currency: {
      type: String,
      default: '¥'
    }
  }
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/card/index.js
// module id = 596
// module chunks = 1